module.exports = __webpack_public_path__ + "static/media/pic.2a28d538.webp";